import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h2 className="font-heading text-xl md:text-2xl font-semibold mt-6 text-foreground-900">
          Strona nie została znaleziona
        </h2>
        <p className="mt-2 text-base text-foreground-400 font-mono">
          /404
        </p>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">
          Przepraszamy, ale strona, której szukasz, nie istnieje.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-arrow-left-line"></i>
          Wróć na stronę główną
        </Link>
      </div>
    </div>
  );
}